export default __webpack_public_path__ + "static/royal_spear-165e82f5a251809a9f9855c3595a6638.png";